{
  "people": "Pessoas",
  "teams": "Equipes",
  "surnameAlphabetical": "Apelido A-Z",
  "teamsAlphabetical": "Equipes A-Z",
  "addTeamMember": "Adicionar membro da equipe",
  "addSelectedToTeam": "Adicionar selecionado à equipe",
  "allPeople": "Todas as pessoas",
  "removeTeamLeaderMessage": "Essa pessoa não poderá mais editar e adicionar/remover membros da equipe.",
  "removeTeamLeader": "Remover status de líder de equipe",
  "addTeamLeaderMessage": "Essa pessoa poderá editar e adicionar/remover membros da equipe.",
  "addTeamLeader": "Adicionar status de líder de equipe",
  "add_people": {
    "add_user": "Adicionar usuário",
    "invite_people_to_the_project": "Envie convites para participar do projeto",
    "email": "E-mail",
    "team": "Equipe",
    "separate_comma": "Separe vários endereços com uma vírgula",
    "add_invitee_team": "Adicionar convidado (s) a uma equipe",
    "add_more": "Adicione mais",
    "project_admin": "Administrador do projeto",
    "sso": "Habilitar sso"
  },
  "remove_people": {
    "remove_user": "Remover usuário",
    "remove_user_title": "Remover esse usuário do projeto",
    "remove_user_message": "Isso desativará a conta do usuário selecionado no projeto e ele não poderá mais fazer login.",
    "remove_user_message_continue": "Tem certeza de que deseja continuar?",
    "remove_people_success": "Usuário removido com sucesso do projeto"
  },
  "reset_password": {
    "reset_password_title": "Enviar link de redefinição de senha",
    "reset_password_message": "Isso enviará um link de redefinição de senha para as pessoas que você selecionou.",
    "reset_password_message_continue": "Você gostaria de continuar?",
    "reset_password_success": "Link de redefinição de senha enviado com sucesso para pessoas selecionadas"
  },
  "sso": {
    "title": "Habilitar SSO",
    "confirm": "Isso habilitará o SSO para as pessoas selecionadas.",
    "continue": "Você gostaria de continuar?",
    "success": "SSO habilitado com sucesso para pessoas selecionadas"
  },
  "sso_disable": {
    "title": "Desativar SSO",
    "confirm": "Os usuários selecionados não conseguiriam mais fazer login via Single Sign On e precisariam se autenticar usando uma senha.",
    "continue": "Você gostaria de continuar?",
    "success": "SSO desativado com sucesso para pessoas selecionadas"
  },
  "removeFromTeamMessage1": "Essa pessoa não fará mais parte da equipe e perderá todas as permissões de visualização e edição associadas a essa equipe.",
  "removeFromTeamMessage2": "Tem certeza de que deseja continuar?",
  "removeFromTeamTitle": "Remover essa pessoa da equipe",
  "removeFromTeamOverflowOption": "Remover da equipe",
  "createANewTeam": "Crie uma nova equipe",
  "nameOfTeam": "Nome da equipe",
  "createNewTeam": "Crie uma nova equipe",
  "teamLeader": "Líder da equipe",
  "toasts": {
    "add_team_success": "Equipe criada com sucesso",
    "add_team_error": "Falha ao criar equipe",
    "invite_success": "Convite (s) enviado (s) com sucesso",
    "invite_error": "Falha ao enviar o convite porque {{ reason }}",
    "removeFromTeamSuccess": "Removido da equipe com sucesso",
    "removeFromTeamError": "Falha ao remover da equipe",
    "setTeamLeaderSuccess": "Definiu com sucesso o status de líder da equipe",
    "setTeamLeaderError": "Falha ao definir o status de líder da equipe",
    "deleteTeamSuccess": "Equipe excluída com sucesso",
    "deleteTeamError": "Falha ao excluir a equipe"
  },
  "amount_teams_selected": "{{ amount }} Equipes selecionadas",
  "invalid_email_address": "Endereço de e-mail inválido",
  "one_or_more_email_not_valid": "Um ou mais e-mails não são válidos",
  "select_one_team": "Selecione uma equipe ou mais",
  "deleteTeamTitle": "Excluir equipe",
  "deleteTeamMessage": "Tem certeza de que deseja excluir a equipe: {{ team }}"
}